import React, { useRef , useState} from "react";
import Frame from "./Frame";
import {Box, useTheme, Typography,Button, ButtonBase} from "@mui/material";
import { tokens } from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import { addFrame } from "../../slices/sign_image_editor"

const FramesList = (props) =>  {

  const { width, height, selectedColor , background, signHeight, signWidth} = props;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const frames = useSelector((state) => state.imageEditor.frames);
  const selectedFrame = useSelector((state) => state.imageEditor.selectedFrame);

  const canDelete = frames.length > 1 ? true : false;

  const addNewFrame = () =>{
    dispatch(addFrame());

  }

  return (
    <Box 
      width = "100%"
      backgroundColor={colors.primary[300]} 
      sx={{ borderRadius:2}}
      p=".5rem 1rem .5rem 1rem"
    >

      <Typography variant="h3" align="left">Frames</Typography>

        <Box
            display = "flex"
            justifyContent="flex-start"
            mt=".6rem"
            mb=".5rem"
            width = "100%"
            backgroundColor={colors.primary[200]} 
            sx={{border: `1px solid ${theme.palette.primary.main}`}}
        >
          {
            frames.map((frame) => ( 
              <Frame key={frame.id} id={frame.id} canDelete={canDelete} selected={frame.id === selectedFrame}/> 
            ))
          }

        </Box>

        <Button
          color="secondary" 
          variant="contained" 
          onClick={addNewFrame}
          size="small"
        >
          <Typography variant="h3">+</Typography>
        </Button>
      </Box>

  );
}

export default FramesList;